import React, { useState } from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import NavBar from "./NavBar";
import Footer from "./Footer";

// Import your gallery images and videos
import logoNew from "./images/logo-new.jpg";
import roofFullStory1Thumb from "./images/dizaverfullstory1-thumb.jpg";
import roofStory2Thumb from "./images/dizaverstory2-thumbnail.jpg";
import roof1Video from "./videos/roof1.mp4";
import roof1Thumb from "./images/roof1-thumb.png";
import roof2Video from "./videos/roof2.mp4";
import roof2Thumb from "./images/roof2-thumb.png";
import roof3Video from "./videos/roof3.mp4";
import roof3Thumb from "./images/roof3-thumb.png";
import roof4Video from "./videos/roof4.mp4";
import roof4Thumb from "./images/roof4-thumb.png";
import roof5Video from "./videos/roof5.mp4";
import roof5Thumb from "./images/roof5-thumb.png";
import roof6Video from "./videos/roof6.mp4";
import roof6Thumb from "./images/roof6-thumb.png";

// Helper for iOS detection (same as your main gallery)
const isIOS = () => {
  if (typeof navigator === "undefined") return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

const galleryItems = [
  {
    src: "https://www.youtube.com/embed/-JOyAfEe-Pc?si=2KrC-PT0KHQVDQkW",
    alt: "Dizaver Aluminum Story",
    type: "youtube",
    poster: logoNew,
  },
  {
    src: "https://www.youtube.com/embed/kAouAXW4IN8?si=fmMFtCoa9U4rp9vv",
    alt: "Roof Installation Project",
    type: "youtube",
    poster: roofFullStory1Thumb,
  },
  {
    src: "https://www.youtube.com/embed/2EamNRb4uoQ?si=9SVrda-qPUQcG0Cx",
    alt: "Gutter Guard Installation",
    type: "youtube",
    poster: roofStory2Thumb,
  },
  {
    src: roof1Video,
    alt: "Project 1",
    type: "video",
    poster: roof1Thumb,
  },
  {
    src: roof2Video,
    alt: "Project 2",
    type: "video",
    poster: roof2Thumb,
  },
  {
    src: roof3Video,
    alt: "Project 3",
    type: "video",
    poster: roof3Thumb,
  },
  {
    src: roof4Video,
    alt: "Project 4",
    type: "video",
    poster: roof4Thumb,
  },
  {
    src: roof5Video,
    alt: "Project 5",
    type: "video",
    poster: roof5Thumb,
  },
  {
    src: roof6Video,
    alt: "Project 6",
    type: "video",
    poster: roof6Thumb,
  },
];

const GalleryPage = () => {
  const [enlargedImg, setEnlargedImg] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <NavBar
        anchorEl={anchorEl}
        handleMenuOpen={handleMenuOpen}
        handleMenuClose={handleMenuClose}
      />
      <Box sx={{ py: { xs: 4, md: 8 }, display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
        <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 }, display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Box sx={{ mb: { xs: 4, md: 6 }, display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
            <Typography
              variant="h3"
              align="center"
              sx={{
                mb: 2,
                fontWeight: 900,
                letterSpacing: { xs: 1, md: 2 },
                fontSize: { xs: "1.8rem", md: "2.5rem" },
                fontFamily: '"Bungee", "Montserrat", Arial, sans-serif',
                textTransform: "uppercase",
                background: "linear-gradient(135deg, #d0d0d0 0%, #808080 50%, #e0e0e0 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                textShadow: "2px 2px 4px rgba(0,0,0,0.3), -1px -1px 2px rgba(255,255,255,0.6)",
              }}
            >
              Gallery
            </Typography>
            <Box sx={{
              width: 120,
              height: 5,
              borderRadius: 3,
              background: "linear-gradient(90deg, #FFD700 0%, #FFC107 100%)",
            }} />
          </Box>
          <Grid container spacing={{ xs: 2, md: 3 }} justifyContent="center" sx={{ width: "100%", ml: { xs: 0, md: "80px" }, maxWidth: { xs: "100%", md: "1100px" } }}>
          {galleryItems.map((img, idx) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={idx}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: { xs: "100%", sm: "100%", md: "auto" },
              }}
            >
              <Box
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: 3,
                  cursor: "pointer",
                  transition: "transform 0.2s",
                  width: { xs: 280, sm: 320 },
                  maxWidth: 320,
                  height: 200,
                  background: "#eee",
                  position: "relative",
                  "&:hover": { transform: "scale(1.03)" },
                }}
                onClick={() => setEnlargedImg(img)}
              >
                {img.type === "video" ? (
                  <>
                    {isIOS() ? (
                      <img
                        src={img.poster || "/video-thumb.jpg"}
                        alt={img.alt}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    ) : (
                      <video
                        src={img.src}
                        poster={img.poster || "/video-thumb.jpg"}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                        muted
                        loop
                        playsInline
                        preload="metadata"
                      />
                    )}
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "rgba(255,255,255,0.85)",
                        bgcolor: "rgba(0,0,0,0.35)",
                        borderRadius: "50%",
                        p: 0.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        pointerEvents: "none",
                      }}
                    >
                      <PlayCircleOutlineIcon sx={{ fontSize: 56 }} />
                    </Box>
                  </>
                ) : img.type === "youtube" ? (
                  <img
                    src={img.poster}
                    alt={img.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                ) : (
                  <img
                    src={img.src}
                    alt={img.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                )}
                {img.type === "youtube" && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      color: "rgba(255,255,255,0.85)",
                      bgcolor: "rgba(0,0,0,0.35)",
                      borderRadius: "50%",
                      p: 0.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      pointerEvents: "none",
                    }}
                  >
                    <PlayCircleOutlineIcon sx={{ fontSize: 56 }} />
                  </Box>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
        {enlargedImg && (
          <Box
            onClick={() => setEnlargedImg(null)}
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              bgcolor: "rgba(0,0,0,0.75)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1300,
              cursor: "zoom-out",
            }}
          >
            {enlargedImg.type === "video" ? (
              <video
                src={enlargedImg.src}
                controls
                autoPlay
                style={{
                  maxWidth: "90%",
                  maxHeight: "90%",
                  borderRadius: 8,
                  boxShadow: "0 8px 32px rgba(25,118,210,0.18)",
                  background: "#000",
                }}
              />
            ) : enlargedImg.type === "youtube" ? (
              <iframe
                width="900"
                height="506"
                src={enlargedImg.src}
                title={enlargedImg.alt}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  maxWidth: "90%",
                  maxHeight: "90%",
                  borderRadius: 8,
                  boxShadow: "0 8px 32px rgba(25,118,210,0.18)",
                  background: "#000",
                }}
              />
            ) : (
              <img
                src={enlargedImg.src}
                alt={enlargedImg.alt}
                style={{
                  maxWidth: "90%",
                  maxHeight: "90%",
                  borderRadius: 8,
                  boxShadow: "0 8px 32px rgba(25,118,210,0.18)",
                  transition: "transform 0.3s",
                }}
              />
            )}
          </Box>
        )}
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default GalleryPage;